export default "__VITE_ASSET__C2WP5wZN__"